<template>
  <layout :drawer="true" :drawerShow="true" :drawerWidth="350">
    <template slot="nav">
      <v-tabs>
        <v-tab @click="setDefaultView(true)">Agences</v-tab>
        <v-tab @click="setDefaultView(false)">Non visitées</v-tab>
      </v-tabs>
    </template>
    <template slot="drawer">
      <KeepAlive>
        <component :is="currentDrawer" :bus="widgetBus"/>
      </KeepAlive>
    </template>
    <template slot="content">
      <KeepAlive>
        <component :is="currentView" :bus="widgetBus"/>
      </KeepAlive>
    </template>
  </layout>
</template>
<script>
import Layout from "@/views/Layout.vue";
import CommercialNotVisitedAgenciesDrawer from "@/views/hlagons/commercialLogs/CommercialNotVisitedAgenciesDrawer.vue";
import CommercialLogListDrawer from "@/views/hlagons/commercialLogs/CommercialLogListDrawer.vue";
import CommercialNotVisitedAgencies from "@/views/hlagons/commercialLogs/CommercialNotVisitedAgencies.vue";
import CommercialLogList from "@/views/hlagons/commercialLogs/CommercialLogList.vue";
import Vue from "vue";

export default {
  name: "CommercialLogs",
  components: {
    Layout,
    CommercialNotVisitedAgencies,
    CommercialLogList
  },
  data() {
    return {
      widgetBus: new Vue(),
      currentView: CommercialLogList,
      currentDrawer: CommercialLogListDrawer,
    }
  },
  methods: {
    setDefaultView(isDefaultView) {
      this.currentView = isDefaultView ? CommercialLogList : CommercialNotVisitedAgencies;
      this.currentDrawer = isDefaultView ? CommercialLogListDrawer : CommercialNotVisitedAgenciesDrawer;
    },
  }
}
</script>
